<template>
  <div class="">
    <el-table ref="multipleTable" row-key="id" :data="tableData" tooltip-effect="light" :header-cell-style="{ backgroundColor: '#ffffff', color: '#000' }">
      <el-table-column label="流水单号" align="center" width="200">
        <template slot-scope="scope">
          {{ scope.row.paymentSn || '-' }}
          <span v-if="scope.row.costType" class="tips" :style="{ backgroundColor: `${scope.row.costType === 2 ? '#31A8FF' : '#00B42A'}` }">
            {{ scope.row.costType === 2 ? '预存' : '费用' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="应收金额" align="center">
        <template slot-scope="scope">￥{{ Number(scope.row.orderAmount || 0).toFixed(2) }}</template>
      </el-table-column>
      <el-table-column label="优惠金额" align="center">
        <template slot-scope="scope">￥{{ Number(scope.row.preferentialAmount || 0).toFixed(2) }}</template>
      </el-table-column>
      <el-table-column label="收款金额" align="center">
        <template slot-scope="scope">￥{{ Number(scope.row.payAmount || 0).toFixed(2) }}</template>
      </el-table-column>
      <el-table-column label="退款金额" align="center">
        <template slot-scope="scope">￥{{ Number(scope.row.returnAmount || 0).toFixed(2) }}</template>
      </el-table-column>
      <el-table-column label="支付方式" align="center">
        <template slot-scope="scope">
          {{ dictType('payWay', scope.row.payWayId) }}
        </template>
      </el-table-column>
      <el-table-column label="收款时间" align="center" width="180">
        <template slot-scope="scope">
          {{ scope.row.payTime || '-' }}
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pt-30"
      layout="total, prev, pager, next, jumper,sizes"
      :current-page.sync="page.pageNo"
      :page-size.sync="page.pageSize"
      :page-sizes="[10, 50, 100]"
      :total="total"
      @size-change="currentChange"
      @current-change="currentChange"
    />
  </div>
</template>

<script>
import { paymentRecordPage, paymentRecordCount } from '@/api/finance'
export default {
  inject: ['indexThis'],
  data() {
    return {
      tableData: [],
      page: {
        pageNo: 1,
        pageSize: 10,
      },
      total: 0,
    }
  },
  created() {
    this.orderList()
  },
  methods: {
    async orderList(params = {}) {
      const { data: res } = await paymentRecordPage({
        ...this.page,
        communityId: this.indexThis.communityId,
        ...params,
        buildingRoomIds: [this.indexThis.buildingRoomId],
      })
      this.tableData = res
      const { data: total } = await paymentRecordCount({
        ...this.page,
        communityId: this.indexThis.communityId,
        ...params,
        buildingRoomIds: [this.indexThis.buildingRoomId],
      })
      this.total = parseInt(total)
    },

    // 查看详情
    currentChange() {
      this.orderList()
    },
  },
}
</script>

<style lang="less" scoped>
.tips {
  padding: 2px 4px;
  border-radius: 4px;
  font-size: 10px;
  margin-left: 10px;
  color: #ffffff;
}
.disabled {
  background: #f6f6f6 !important;
  color: #acacac !important;
}
</style>
